<template>
    <span
        :uk-tooltip="
            disabled
                ? 'title:' + $t('x.module.disabled.hint', {x: $t('whiteLabel')})
                : ''
        "
        :class="disabled ? 'module-disabled-struct' : ''">
        <span
            :class="
                disabled ? 'module-disabled uk-height-1-1' : 'uk-height-1-1'
            ">
            <LabelWithError
                is-optional
                :error="inputError"
                :label="$t(title)"
                is-dark />
            <Description v-if="description" :text="$t(description)" />

            <Modal
                :id="'modal-media-file' + id"
                is-without-body
                is-close-outside>
                <div class="uk-text-center favicon-struct">
                    <img
                        v-if="input"
                        class="favicon"
                        :src="getLocalFileUrl(input)"
                        uk-img />
                    <img
                        v-else-if="favicon"
                        class="favicon"
                        :src="
                            apiUrl +
                            '/manage-clickandbuys/' +
                            id +
                            '/media/' +
                            favicon +
                            '?token=' +
                            getToken
                        "
                        uk-img />
                </div>
            </Modal>

            <div
                class="uk-position-relative favicon-struct uk-text-center"
                :id="'upload-media-file' + id">
                <img
                    v-if="input"
                    class="favicon"
                    :src="getLocalFileUrl(input)"
                    uk-img />
                <img
                    v-else-if="favicon"
                    class="favicon"
                    :src="
                        apiUrl +
                        '/manage-clickandbuys/' +
                        id +
                        '/media/' +
                        favicon +
                        '?token=' +
                        getToken
                    "
                    uk-img />
                <div
                    v-else
                    class="ogimage uk-light uk-flex uk-flex-middle uk-flex-center">
                    {{ $t('no.x', {x: $t(title)}) }}
                </div>
            </div>

            <div
                class="uk-card uk-card-body uk-padding-xsmall control secondary-with-border">
                <div class="uk-flex-center uk-flex" uk-grid>
                    <div>
                        <span v-on:click="triggerInputDialog()">
                            <Icon
                                :ratio="1.3"
                                :uk-tooltip="
                                    'title:' +
                                    $t(input || favicon ? 'replace' : 'add')
                                "
                                class="cursor-pointer action-icon"
                                icon="cloud-upload" />
                        </span>

                        <input
                            :id="'media-file' + id"
                            :ref="'mediafile' + id"
                            :accept="'.' + fileExtensions.join(', .')"
                            type="file"
                            class="uk-hidden"
                            v-on:click="$refs['mediafile' + id].value = null"
                            v-on:change="handleChange()" />
                    </div>

                    <div v-if="false && (input || favicon)">
                        <ToggleItem :toggle="'target: #modal-media-file' + id">
                            <Icon
                                :ratio="1.3"
                                :uk-tooltip="'title:' + $t('show')"
                                class="cursor-pointer action-icon"
                                icon="search" />
                        </ToggleItem>
                    </div>

                    <div v-if="input || favicon">
                        <span v-on:click="handleDelete()">
                            <Icon
                                :ratio="1.5"
                                :uk-tooltip="'title:' + $t('delete')"
                                class="cursor-pointer action-icon"
                                icon="trash" />
                        </span>
                    </div>
                </div>
            </div>
        </span>
    </span>
</template>

<script>
import Icon from '@/components/generic/Icon.vue';
import Modal from '@/components/generic/Modal.vue';
import ToggleItem from '@/components/generic/ToggleItem.vue';
import Description from '@/components/Description.vue';
import LabelWithError from '@/components/generic/LabelWithError.vue';

export default {
    name: 'ClickAndBuyMediaForm',
    components: {
        LabelWithError,
        Description,
        ToggleItem,
        Modal,
        Icon,
    },
    props: {
        id: String,
        data: String,

        allowedExtensions: Array,
        allowedSize: Number,

        disabled: Boolean,
    },
    created() {
        this.favicon = this.data;
    },
    mounted() {
        // window.addEventListener('dragover', this.dragoverListener, false);
        // window.addEventListener('drop', this.dropListener, false);
    },
    data() {
        return {
            title: 'media',
            description: '',

            loading: false,
            success: false,
            error: null,

            input: null,
            inputError: null,
            favicon: null,
        };
    },
    computed: {
        fileExtensions() {
            const extensions = this.allowedExtensions;

            if (!extensions || extensions.length === 0) {
                return [];
            }

            const lower = extensions.map((element) => {
                return element.toLowerCase();
            });

            return [...new Set(lower)];
        },
    },
    methods: {
        dragoverListener(e) {
            e.preventDefault();

            let element = document.getElementById(
                'upload-media-file' + this.id
            );
            if (element) {
                element.classList.add('dragover');
            }
        },
        dropListener(e) {
            e.preventDefault();

            let element = document.getElementById(
                'upload-media-file' + this.id
            );
            if (element) {
                element.classList.remove('dragover');
            }

            let files = e.dataTransfer.files;

            this.handleFileInput(files[0]);
        },
        triggerInputDialog() {
            document.getElementById('media-file' + this.id).click();
        },
        handleDelete() {
            this.success = false;
            this.favicon = null;
            this.input = null;

            this.$emit('file', null);
        },
        handleChange() {
            let file = this.$refs['mediafile' + this.id].files[0];
            if (!file) {
                return;
            }

            this.handleFileInput(file);
        },
        handleFileInput(file) {
            let fileExtension = file.name.split('.').pop();
            fileExtension = fileExtension.toLowerCase();
            if (!this.fileExtensions.includes(fileExtension)) {
                this.inputError = this.$t('file.type.error', {
                    name: this.$t(this.title),
                    types: this.getFormattedTypesString(this.fileExtensions),
                });

                return;
            }

            if (file.size > this.allowedSize * 1024 * 1024) {
                this.inputError = this.$t('file.size.error', {
                    name: this.$t(this.title),
                    mb: this.allowedSize,
                });
                return;
            }

            this.inputError = null;
            this.error = null;
            this.success = false;
            this.input = file;

            this.$emit('file', file);
        },
    },
};
</script>

<style lang="scss" scoped>
.favicon {
    max-width: 256px;
    max-height: 256px;

    width: 100%;
    height: 100%;
}

.favicon-struct {
    padding: 15px;
    background-color: rgba(34, 34, 34, 0.72);
    border: 1px rgba(34, 34, 34, 0.72) solid;
    backdrop-filter: saturate(180%) blur(20px);
    transition: background-color 0.25s linear;
}

.dragover {
    background-color: rgba(34, 34, 34, 0.4);
    border: 1px rgba(34, 34, 34, 0.72) dashed;
}
</style>
